export const BID_TYPES = {
    FIXED: 'FIXED',
    OPTIMIZED_CONVERSIONS: 'OPTIMIZED_CONVERSIONS',
    OPTIMIZED_PAGEVIEWS: 'OPTIMIZED_PAGEVIEWS',
};
